class ScrollToCouponFeedback {
    constructor(){
        $(function() {
            if(document.documentElement.clientWidth<1024){
                var feedbackPresent = $(".shop-coupon-input.coupon_attempted");
                if (feedbackPresent.length) {
                    var firstError = feedbackPresent.first();
                    var target = $(firstError);
                    $("html, body").animate(
                        {
                            scrollTop: $(target).offset().top - 50
                        },
                        1000
                    );
                }
            }
        });
    }
};

export default ScrollToCouponFeedback;
